import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VModal from 'vue-js-modal';
import  'bootstrap-icons/font/bootstrap-icons.css'


axios.defaults.baseURL = "https://apibi.gruposolimano.com.pe/api/"

// axios.defaults.baseURL = "https://localhost:7082/api/"

Vue.config.productionTip = false
Vue.use(Vueaxios , axios ,VModal)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
